/**
 * Imports
 *
 * Import any modules or components here.
 */

import { homePage, homePageModal } from "./home";
import { importantDocumentsPage } from "./important-documents";
import { faqsPage } from "./faqs";
import { contactPage } from "./contact";

import { defaultPage } from "./default";
import { errorPage } from "./error";

export class Page {
    constructor(pages, slug, dates) {
        this.pages = pages;
        this.slug = slug;
        this.dates = dates;
    }

    /**
     * Represents the home function.
     *
     * @param {Function} constructor - The constructor function for the home page.
     * @param {Function} plugin - The plugin function for the home page modal.
     */
    home(render = homePage, plugin = []) {
        render(this);
        plugin.forEach((plugin) => plugin(this));
        // default modal
        homePageModal(this);
    }

    /**
     * Represents a function for handling important documents.
     *
     * @param {Object} render - The render object.
     * @param {Object} plugin - The plugin object.
     */
    important_documents(render = importantDocumentsPage, plugin = []) {
        render(this, this.dates);
        plugin.forEach((plugin) => plugin(this));
    }

    /**
     * Represents the FAQs page.
     * @param {Object} render - The render object.
     * @param {Object} plugin - The plugin object.
     */
    faqs(render = faqsPage, plugin = []) {
        render(this);
        plugin.forEach((plugin) => plugin(this));
    }

    /**
     * Represents a contact method.
     *
     * @param {Object} render - The render object for the contact page.
     * @param {Array} plugin - An array of plugins for the contact page.
     */
    contact(render = contactPage, plugin = []) {
        render(this);
        plugin.forEach((plugin) => plugin(this));
    }

    /**
     * Represents an error in the Page class.
     * @param {Function} render - The render function of the error page.
     * @param {Object} plugin - The plugin object associated with the error.
     */
    error(render = errorPage, plugin = []) {
        render(this);
        plugin.forEach((plugin) => plugin(this));
    }

    /**
     * Represents the default page.
     * @param {Function} render - The render function of the default page.
     * @param {Object} plugin - The plugin object associated with the default page.
     */
    default(render = defaultPage, plugin = []) {
        render(this);
        plugin.forEach((plugin) => plugin(this));
    }
}
